import { environment } from '../../environments/environment';
import {AnalyticsOutcome} from "../common/model/analytics-outcome.model";

export class LoginConfig {

  private static BS_REGULAR_DOMAIN = environment.bs_regular_domain;

  // Login
  public static GROW_BACKEND_LOGIN_TO_UNIVERSITY_ENDPOINT = `${environment.login_backend_domain}/auth/loginToUniversity`;

  //SSO
  public static SSO_REDIRECT_ENDPOINT = `${environment.sso_redirect_url}`;

  // Reset Password
  public static GROW_BACKEND_RESET_PASSWORD_ENDPOINT = `${environment.new_login_backend_path}/auth/setPassword`;
  public static GROW_BACKEND_SEND_RESET_PASSWORD_EMAIL_ENDPOINT = `${environment.login_backend_domain}/userMangment/resetPasswordById`;
  public static GROW_BACKEND_SEND_UNIFIED_RESET_PASSWORD_EMAIL_ENDPOINT = `${environment.new_login_backend_path}/auth/forgotPassword`;
  public static GROW_BACKEND_RESET_PASSWORD_TOKEN_VALIDATION_ENDPOINT = `${environment.new_login_backend_path}/auth/verifyResetPassword`;

  // 2FA By Email / SMS
  public static GROW_BACKEND_2FA_VERIFY_ENDPOINT = `${environment.login_backend_domain}/auth/verifyTwoFactorAuthCode`;
  public static GROW_BACKEND_SEND_2FA_CODE_ENDPOINT = `${environment.login_backend_domain}/auth/resendTwoFactorAuthCode`;

  // 2FA By QR Code
  public static GROW_BACKEND_GET_START_TOTP_ENDPOINT = `${environment.login_backend_domain}/auth/startTotp`;
  public static GROW_BACKEND_VERIFY_TOTP_CODE_ENDPOINT = `${environment.login_backend_domain}/auth/verifyTotpCode`;

  // Connect user with token from ice-signup
  public static GROW_BACKEND_CONNECT_USER_ENDPOINT = `${environment.login_backend_domain}/contributor/connectGrowUser`;

  // Connect user with clientId from Swapper
  public static GROW_BACKEND_CONNECT_USER_WITH_CLIENT_ID_ENDPOINT = `${environment.login_backend_domain}/contributor/connect`;

  // Website Backend Login Ads endpoint
  public static WEBSITE_BACKEND_LOGIN_ADS_ENDPOINT = `${environment.website_domain}/login-banners/login`;

  // Website Backend Am I from Europe
  public static WEBSITE_BACKEND_AM_I_EU_ENDPOINT = `${environment.website_domain}/am-i-eu`;

  // Website Backend Whats My country
  public static WEBSITE_BACKEND_WHAT_IS_MY_COUNTRY = `${environment.website_domain}/whatsmycountryjson`;

  //  Website Backend send lead endpoint
  public static WEBSITE_SEND_LEAD_ENDPOINT = `${environment.website_domain}/business/send-lead-to-crm?titlefilter=true`;

  // BS get home page for user
  public static BS_USER_INFO_ENDPOINT = `${LoginConfig.BS_REGULAR_DOMAIN}/userinfo`;
  public static GROW_BACKEND_USER_DETAILS_ENDPOINT = `${environment.new_login_backend_path}/userData/userDetails`;

  // Toggle User endpoint on Login BE
  public static LOGIN_BE_TOGGLE_USER_ENDPOINT = `${environment.login_backend_domain}/auth/toggleUser`;
  public static LOGIN_BE_OAUTH2_LOGIN_BY_TOKEN_ENDPOINT = `${environment.login_backend_domain}/auth/oauth2/unified/oauthLoginByToken`;
  public static LOGIN_BE_SUCCESSFUL_LOGIN = `${environment.new_login_backend_path}/auth/successfulLogin`;

  // Password Reset
  public static UMS_PASSWORD_RESET_ENDPOINT = `${environment.ums_password_reset_url}`;  // NOSONAR

  // Biometric (WebAuthn) MFA enrollment
  public static UMS_MFA_WEBAUTHN_ENDPOINT = `${environment.ums_mfa_webauthn_url}`;  // NOSONAR

  // Skiljarr
  public static ZOOM_UNIVERSITY_DOMAIN_STRING = 'university.zoominfo.com';
  public static ZOOM_UNIVERSITY_DOMAIN = `https://${LoginConfig.ZOOM_UNIVERSITY_DOMAIN_STRING}`;
  public static SKILLJAR_LOGIN_ENDPOINT = '/auth/login/callback';

  // Goolge Re-Captcha
  public static GOOGLE_RE_CAPTCHA_SITE_KEY = '6LddsRAUAAAAAMrifZ0vFRCd-S5K7WcoqiAfD_TO';
  public static CAPTCHA_ERR_MESSAGE = 'You still have one more step to do ...';

  public static DOZI_MOBILE_APP_LINK = 'https://www.zoominfo.com/solutions/mobile-app';
  public static DOZI_SALESFORCE_BANNER_CTA = "https://listen.casted.us/public/57/In-Your-Corner-faa3c287/46de9d2a";
  public static DOZI_CRB_BANNER_CTA = "https://video.zoominfo.com/watch/moRphW6k6D7ihTMsDk3f9J?";
  public static DOZI_ENGAGE_BANNER_CTA = "https://www.zoominfo.com/offers/engage-learn-more?camp_ID=7014y000001t4vpAAA";
  public static DOZI_CHORUS_BANNER_CTA = "https://www.zoominfo.com/products/chorus";

  // Prefix Redirect URLs
  // Keeping ReachOut prefix URLs separated for future possible changes
  public static DOZI_REACHOUT_PREFIX_URL = `/#/reachout`;
  public static ZI_REACHOUT_PREFIX_URL = `/#/reachout`;
  public static SFNA_PREFIX_URL = `/#/native-plugin/salesforce`;
  public static MDNA_PREFIX_URL = `/#/native-plugin/dynamics`;
  public static NATIVE_PLUGIN_PREFIX_URL = `/#/native-plugin`;

  // SFNA session storage post URL
  public static SESSION_STORAGE_POST_URL = `/wmh.html`;

  // Engage Ext url
  public static OUTLOOK_POSTFIX_URL = `/#/outlookext?isOutlook=true`;
  public static ENGAGE_EXT_POSTFIX_URL = `/#/engageext?isExt=true`;
  public static ENGAGE_EXT_GMAIL_POSTFIX = '&isGmailExt=true';
  // GROW URLs
  public static GROW_PROSPECTING_PAGE = '/#/apps/prospecting/';

  //  URLs to differentiate login origins
  public static MOBILE_URL = '/webview';
  public static REACHOUT_URL = '/roview';
  public static SFNA_URL = '/sfnaview';
  public static COPILOT_WS_URL = '/cwsview';
  public static GTMC_URL = '/gtmcview';  // ZI Chat App

  // ZI-Lite sign up URL
  public static CE_SIGN_UP_URL = `${environment.signup_url}`;
  public static SIGN_UP_URL = 'https://signup.zoominfo.com/#/?origin=WebLogin';

  // Free Trial Page
  public static FREE_TRIAL_URL = 'https://www.zoominfo.com/free-trial';
  // Free Trial Page's CampId
  public static FREE_TRIAL_URL_CAMP_ID = '7017y00001JV0I5AAL';
  // Free Trial Page's CampId for mobile
  public static FREE_TRIAL_URL_CAMP_ID_MOBILE = '7017y00001JWW6CAAX';
  // Free Trial Page's CampId
  public static LOGIN_REDIRECT_CAMP_ID = '7011U000000US9VQAW';
  // Free Trial Page's CampId with branded utm_campaign
  public static LOGIN_REDIRECT_CAMP_ID_BRANDED_UTM_CAMPAIGN = '7013p000001ebF1AAI';
  // Free Trial Page's CampId on reachout extension
  public static LOGIN_REDIRECT_CAMP_ID_REACHOUT = '7013p000002IOoIAAW';
  // Free Trial Page's CampId for LZI login page
  public static LOGIN_REDIRECT_CAMP_ID_LZI = '7014y000001t6UxAAI';

  // Free Trial Mobile Pages CampId
  public static MOBILE_FREE_TRIAL_CAMP_ID = '7013p0000015qHdAAI';

  // Free Trial EMEA Banner CampId
  public static FREE_TRIAL_URL_CAMP_ID_EMEA_BANNER = '7017y00001jyJdJAAU';

  // The string convention that is getting used on whole login module
  public static MACHINE_ID_STRING_CONVENTION = 'machineId';
  public static MACHINE_ID_STRING_CONVENTION_OKTA = 'oktaMachineId';
  public static ACTIVE_USER_COOKIE_NAME = 'ziUser'; // this is for back compatibility - users to represent a logged in user without considering the platform
  public static ACTIVE_ZI_USER_COOKIE_NAME = 'lziUser';
  public static ACTIVE_DOZI_USER_COOKIE_NAME = 'doziUser';
  public static ACTIVE_RECRUITER_USER_COOKIE_NAME = 'recruiterUser';
  public static ACTIVE_MARKETING_CLOUD_USER_COOKIE_NAME = 'marketingCloudUser';
  public static LOOP_COOKIE_NAME = '_zi_login_cnt';
  public static LOOP_COOKIE_EXPIRATION = 45 * 1000;
  public static PROVISIONING_COOKIE_NAME = 'freeTrialResponse';
  public static REFERRER_COOKIE_NAME = 'ziReferrer';
  public static PROVISIONING_COOKIE_EXPIRATION = 1 / 24 / 60 / 60 * 30; // 30 seconds in days
  public static ALLOW_ALL_2FA_METHODS = 'force_allow_all_2fa_methods';
  public static LATEST_TOKEN_EXPIRATION_COOKIE_NAME = 'zitokencachebust';
  public static readonly COPILOT_USER_COOKIE_NAME = 'isCopilotUser';

  // Employee Users are blocked from email 2FA
  public static EMPLOYEE_USERS_BLOCK_EMAIL_ERR_CODE = 969;
  public static EMPLOYEE_USERS_BLOCK_EMAIL_ERR_DEFAULT_MESSAGE = 'ZoomInfo employee users are not allowed to do 2FA by email';

  // Cookies Settings
  public static DEFAULT_EXPIRATION_DATE_FOR_ROUTING_COOKIE = 30;

  // Alerts delays TODO - Move to a higher-level config
  public static ALERTS_DELAY_SHORT = 5000;
  public static ALERTS_DELAY_LONG = 8000;

  // 2FA Codes Settings
  public static NUM_CHARS_GB_2FA_CODE = 5;
  public static NUM_CHARS_G_AUTH_CODE = 6;

  // Login Expiration Error Codes
  public static CODE_EXPIRED_RESP_ERROR_CODES = [9412, 9432];

  // Reset PW Error Codes
  public static RESET_PW_ERR_CODES = [-163];
  public static RESET_PW_MESSAGES = {
    '-163': 'We have upgraded our encryption system to better protect you and your account.<span class="lineBreak-20px"></span>To make sure all passwords are secure, reset your password now.',
  };
  public static INVALID_RESET_PW_TOKEN = -198;
  public static FORGOT_PW_MESSAGES = {
    '-198': 'Your reset password link has expired. Please try again.'
  };

  public static ALLOWED_REDIRECT_URL_HOSTNAMES = [
    '.zoominfo.com'
  ];

  // GTM app hosts (gtm.ai / mcp-connectors, etc.) — honored like gtm_studio_url for the
  // active-user redirect passthrough (see getAppPrecedence). One entry per environment;
  // each host only resolves in its own environment.
  public static readonly GTM_APP_REDIRECT_HOSTNAMES = [
    'gtm.zoominfo.com',
    'gtm-pre-prd.zoominfo.com',
    'gtm-dev.zoominfo.com'
  ];

  public static readonly PENDO_ALLOWED_QUERY_PARAMS = ['pendo', 'step'];

  // Builder/GTM signup-context params forwarded on the final redirect to gtm-studio only
  // (see isRedirectedFromBuilder in url.service.ts) — kept separate from
  // PENDO_ALLOWED_QUERY_PARAMS so they aren't forwarded to unrelated redirect destinations
  // (Recruiter, Engage, Admin, etc.).
  public static readonly BUILDER_SIGNUP_CONTEXT_PARAMS = ['goal', 'useCase', 'Origin', 'UseCaseOrigin', 'builder_type', 'audience'];

  public static REACHOUT = 'ReachOut2.0';

  // Amplitude events for ReachOut
  public static REACHOUT_AMP_EVENTS = {
    signup: {
      eventName: 'SignUp',
      eventProps: {
        application: LoginConfig.REACHOUT,
        source: LoginConfig.REACHOUT,
        signupTo: LoginConfig.REACHOUT,
        action: 'SignUp',
        outcome: {type: AnalyticsOutcome.SUCCESS}
      }
    },
    forgotPassword: {
      eventName: 'ForgotPassword',
      eventProps: {
        application: LoginConfig.REACHOUT,
        forgotPasswordTo: LoginConfig.REACHOUT,
        outcome: {type: AnalyticsOutcome.SUCCESS}
      }
    }
  };

  public static INITIAL_LOGGED_IN_EVENT_PARAMS = {
    application: 'LoginApp',
    Source: 'LoginPage',
    LoginType: 'Credentials'
  };

  public static INITIAL_ERROR_OCCURRED_EVENT_PARAMS = {
    application: 'LoginApp',
    source: 'LoginPage',
    action: 'LoggedIn'
  };

  public static SERVER_ERROR_CODES = [500, 502, 400];
  public static USER_ERROR_CODES = [9404, 9453, 9508, 9967, 9968, 9970, -12, -153, -78];
  public static MULTIPLE_PLATFORM_ERROR_CODE = 431;
  public static USER_NEED_TO_BE_TOGGLED_CODE = 434;

  public static MOBILE_BREAK = 800;

  public static FREE_EMAIL_ENDINGS = ['.edu', "@126.com", "@163.com", "@adelphia.net", "@aim.com", "@aol.com", "@aol.in", "@att.net", "@austin.rr.com", "@bellsouth.net", "@bellsouth.netr", "@bellsystems.biz", "@bigpond.net.au", "@btinternet.com", "@carolina.rr.com", "@cgx1.com", "@charter.net", "@cinci.rr.com", "@cogeco.ca", "@sky.com", "@columbus.rr.com", "@comcast.net", "@comcast.net", "@consultant.com", "@cox.net", "@damails.us", "@earthlink.net", "@ec.rr.com", "@edu", "@email.com", "@embarqmail.com", "@epix.net", "@excite.com", "@fuse.net", "@gmail.ca", "@gmail.co", "@gmail.com", "@gmx.com", "@googlemail.com", "@hawaii.rr.com", "@hotmail.co.uk", "@hotmail.com", "@hotmail.com.ph", "@hotmail.fr", "@hotmail.", "@icloud.com", "@ilwllc.com", "@inbox.com", "@inbox.ru", "@indiatimes.com", "@insight.rr.com", "@insightbb.com", "@ipass.com", "@juno.com", "@la.nfl.net", "@libero.it", "@live.ca", "@live.com", "@live.fr", "@lucintel.com", "@lycos.com", "@lzar.com", "@mac.com", "@mail.com", "@mail.ru", "@mailinator.com", "@maine.rr.com", "@mchsi.com", "@me.com", "@mindspring.com", "@msn.com", "@mycoolhaus.com", "@nc.rr.com", "@netscape.net", "@netzero.com", "@netzero.net", "@new.rr.com", "@nyc.rr.com", "@nycap.rr.com", "@optonline.net", "@outlook.com", "@peoplepc.com", "@post.com", "@prodigy.net", "@qq.com", "@protonmail.com", "@qwest.net", "@rediffmail.com", "@rjwebmail.com", "@rochester.rr.com", "@rocketmail.com", "@rogers.com", "@salesmail.us", "@sbcglobal.net", "@sc.rr.com", "@shaw.ca", "@sify.com", "@snapemedia.com", "@sogetthis.com", "@stratmail.com", "@sympatico.ca", "@tampabay.rr.com", "@telus.net", "@triad.rr.com", "@tx.rr.com", "@us.icap.com", "@usa.net", "@verizon.net", "@videotron.ca", "@vivaldi.net", "@wi.rr.com", "@web.de", "@windstream.net", "@woh.rr.com", "@wowway.com", "@yahoo.ca", "@yahoo.co.in", "@yahoo.in", "@yahoo.co.uk", "@yahoo.com", "@yahoo.com.ar", "@yahoo.com.au", "@yahoo.com.br", "@yahoo.com.cn", "@yahoo.com.mx", "@yahoo.com.ph", "@yahoo.com.sg", "@yahoo.com.tw", "@yahoo.es", "@yahoo.fr", "@ymail.com", "@yopmail.com", "@zapak.com", "@yahoo.it"];

  public static TEXT_VALIDATION_PATTERN = /^[^@]+$/;
  public static PHONE_VALIDATION_PATTERN = /^[+]{0,1}[0-9]+$/;

  public static MOBILE_RESTRICTED_ROUTES = ['/resetPassword'];

  public static TOGGLE_FLOW_DEFAULT_ERR_MESSAGE = `Toggle Flow Failed`;

  public static TOGGLE_FLOWS = {
    LOGIN: 'login',
    TOGGLE_PAGE: 'toggle page on login'
  };

  public static INVALID_OR_MISSING_UUID_ERROR_CODES = [443, 444];

  public static LEGACY_LOGIN_URL_IDENTIFIER = 'lzilogin';

  public static OKTA_DELETE_SESSIONS_ENDPOINT= environment.oktaDeleteSessionUrl;
  public static OKTA_GET_SESSIONS_ME_ENDPOINT= environment.oktaGetSessionsMeUrl;

  // On MDNA, only go to mobile site if window.innerWidth is <= this number of pixels
  public static MDNA_MOBILE_WIDTH_LIMIT = 460;

  // Settings
  public static SETTINGS_CONFIG_ENDPOINT = `${environment.settings_url}/v1/config`;
  public static SETTINGS_PRODUCT_TOUR_ENDPOINT = `${environment.settings_url}/v1/product-tour`;

  public static MINIMUM_LANDSCAPE_WIDTH = 802;  // px

  public static STATUS_PAGE_URL = 'https://status.zoominfo.com/';
  public static PRIVACY_PAGE_URL = 'https://www.zoominfo.com/trust-center/your-privacy';

  public static SHOW_MAINTENANCE_BANNER = false;
  public static IS_TAM_ENABLED = false;
  public static IS_ENGAGE_ENABLED = true;
  public static IS_ADMIN_ENABLED = true;
  public static SHOULD_RECOMMEND_ADMIN = true;
  public static IS_DOZI_LITE_ENABLED = true;
  public static IS_ZI_LITE_RO_SIGNUP_ENABLED = false;

  public static HEADLESS_LICENSE_LANDING_PAGE_PATH = 'headless-license';
  public static NO_ACCESS_LANDING_PAGE_PATH = 'no-access';
  public static ZIL_SETUP_PASSWORD_PAGE_PATH = 'zil-setup-password';
  public static ZIL_PRICING_PAGE_PATH = 'view-plans';
  public static PARTNERS_SETUP_PASSWORD_PAGE_PATH = 'partners-setup-password';

  // OneTrust
  public static ONETRUST_ALLOW_ALL_LOCAL_STORAGE = 'allCookiesAllowed';  // flag for OneTrust allowing all cookies
  public static ONETRUST_CONSENT_COOKIE = 'OptanonConsent';  // OneTrust cookie storing user's consent

  // Remember me
  public static REMEMBER_ME_STORAGE = 'rememberMe';  // username remember me flag
  public static REMEMBER_ME_VALUE_STORAGE = 'rememberMeUsername';  // username value to remember

  // Title
  public static MAIN_PAGE_TITLE = 'ZoomInfo Login';
  public static SSO_PAGE_TITLE = 'Single Sign-On';
  public static FORGOT_PW_PAGE_TITLE = 'Forgot Password';

  // Meta tag
  public static META_DESCRIPTION = 'ZoomInfo login homepage. Log in to your ZoomInfo account using username & password, SSO, Google, or Office 365.';

  // Mobile page
  public static IOS_STORE_URL = 'https://apps.apple.com/il/app/zoominfo/id1493170277';
  public static MOBILE_APP_LINK_HREF = 'https://app.zoominfo.com/#/apps';  // same for staging

  // Mobile login
  public static WEBVIEW_LS = 'isInWebview';
  public static WEBVIEW_COOKIE = 'isInWebview';

  // COPILOT WORKSPACE / GTM WORKSPACE
  public static GTMC_LOGIN_LS = 'isGtmcLogin';
  public static GTMC_LOGIN_COOKIE = 'isGtmcLogin';

  public static USE_OKTA_SMS = true;

  // ADA Support
  public static ADA_SUPPORT_ANSWER_ID = '685321e64e2e38c388dc5cbd';

  // Partner login
  public static PARTNER_LOGIN_INFO_LS = 'partnerLoginInfo';
  public static PARTNER_LOGIN_COOKIE = 'partnerLoginParams';
  public static IDP_ID_COOKIE = 'idpid';
  public static IDP_ID_COOKIE_EXPIRATION = 5 / 24 / 60; // 5 minutes in days

  // Auto Provisioning
  public static PARTNERS_AUTO_PROV_COOKIE = 'partnersAutoProvisioning';

  public static FRAUD_SESSION_KEY_COOKIE = 'fraudSessionKey';

  // OHL
  public static OHL_SSO_REDIRECT_COOKIE = 'ssoRedirectFromOHL';
}
